export default {
  state: {
    visible: false,
    text: '',
    timeout: 2000,
    color: '',
    bottom: false,
    width: 500,
  },
  getters: {
    snackbarVisible(state) {
      return state.visible;
    },
    snackbarText(state) {
      return state.text;
    },
    snackbarTimeout(state) {
      return state.timeout;
    },
    snackbarColor(state) {
      return state.color;
    },
    snackbarBottom(state) {
      return state.bottom;
    },
    snackbarWidth(state) {
      return state.width;
    },
  },
  mutations: {
    showSnackbar(state, params) {
      state.visible = true;
      state.text = params.text;
      state.timeout = params.timeout || 2000;
      state.color = params.color || 'info';
      state.bottom = params.bottom || false;
    },
    setSnackbarVisible(state, v) {
      state.visible = v;
    },
  },
};
